import { createRootRoute } from '@tanstack/react-router'
import { PublicLayout } from '@/components/layout/PublicLayout'
import { HelmetProvider } from 'react-helmet-async'

export const Route = createRootRoute({
  component: () => (
    <HelmetProvider>
      <PublicLayout />
    </HelmetProvider>
  ),
})
